import { List, Selector, Space, Tabs, Slider } from "antd-mobile"
import { InputView, ListView, TabsView, TradeCoinsBodyView, TradeButtonView, TradeHeaderView, DividerTradeView } from "../factory/ViewUtil"
import { CellStateView } from "../factory/CellViews"
import React, { useCallback, useEffect, useImperativeHandle, useState } from "react";
import { isLogin, RequestMarketDepth, RequestTradeCoinUndo, RequestTradeCoinUndone, SendTradeCoin } from "../../NetworkFactory";
import { BigDecimalZero, DecimalComparedToZero, DecimalConvert, ToastClear, ToastContent, ToastLoading, TradeLightValueColor } from "../factory/FactoryUtil";
import { NavbarHistoryIcon } from "../icons";
import { AssetsListener, AssetsListenerRemove, RefreshAssets } from "../assets/AssetsManager";
import { CoinCellView } from "./TradeCellView";

const optionsData = [
    {label: '25%', value: 25},
    {label: '50%', value: 50},
    {label: '75%', value: 75},
    {label: '100%', value: 100}
];

export const CoinTradeViewController = React.forwardRef((props, ref) => {
    
    const [updateCounter, setUpdateCounter] = useState(0)

    const updateSymbolData = (data) => {
        setSymbolData(data)
        setSymbol(data.symbol)
        
        setMarketPrice(data.close + '')
        setUpdateCounter(updateCounter+1)
    }

    const currentSymbolData = () => {
        return symbolData
    }

    //将子组件的方法 暴露给父组件
    useImperativeHandle(ref, () => ({
        currentSymbolData, updateSymbolData
    }))

    const [symbol, setSymbol] = useState(localStorage.getItem('coin_symbol') || 'BTC/USDT');
    const [symbolData, setSymbolData] = useState({
        symbol : symbol,
        open : '0.00',
        close : '0.00', 
        high : '0.00', 
        low : '0.00'
    });

    const [marketPrice, setMarketPrice] = useState('0')
    const [priceType, setPriceType] = useState(true)
    const [tradeType, setTradeType] = useState(true)

    const [price, setPrice] = useState('')
    const [amount, setAmount] = useState('')
    
    const [sliderValue, setSliderValue] = useState(0)
    const [perValue, setPerValue] = useState(0)
    const [tradeButtonText, setTradeButtonText] = useState('...')

    const [depthData, setDepthData] = useState({})

    const [assetsData, setAssetsData] = useState([])
    const [buyAssets, setBuyAssets] = useState({})
    const [sellAssets, setSellAssets] = useState({})
    const [tradeValue, setTradeValue] = useState('0.00')


    const [orderData, setOrderData] = useState([])
    const [stateCode, setStateCode] = useState(4);

    //=========================================================
    const requestUnDoneData = useCallback(() => {
        setStateCode(3)
        RequestTradeCoinUndone(symbol).then(response => {
            const {data = []} = response.data || {}
            setOrderData(data)
            setStateCode(data.length > 0 ? -1 : 1)
        }).catch(() => {
            setStateCode(1)
        })
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps

    // # 刷新交易数据和
    const refreshTradeData = () => {
        setOrderData([])
        requestUnDoneData()
    }

    // # 监听符号变化获取挂单数据
    useEffect(() => {
        if(symbol && isLogin()) {
            refreshTradeData()
        }
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps

    // # 撤单
    const onUndo = ({id = ''}) => {
        if(id.length === 0) {
            ToastContent('Error')
            return
        }
        ToastLoading('Undoing...')
        RequestTradeCoinUndo({id : id + ''}).then(() => {
            ToastClear()
            refreshTradeData()
            RefreshAssets('1')
        }).catch(() => {
            ToastContent('Error')
        })
    }
    //=========================================================


    //=========================================================
    // # 请求深度数据
    const requestDepthData = () => {
        RequestMarketDepth(symbol).then(response => {
            const count = 8
            const {asks = [], bids = []} = response.data || {}
            let asksData = []
            let asksMaxPrice = BigDecimalZero('0')
            for(let i=0;i<asks.length;i++) {
                const {price, amount} = asks[i] || {}
                if(BigDecimalZero(amount).comparedTo(asksMaxPrice) > 0) {
                    asksMaxPrice = BigDecimalZero(amount)
                }

                asksData.push({
                    price : DecimalConvert(price),
                    amount : DecimalConvert(amount)
                })
                if(asksData.length >= count) {
                    break
                }
            }
            let bidsData = []
            let bidsMaxPrice = BigDecimalZero('0')
            for(let i=0;i<bids.length;i++) {
                const {price, amount} = bids[i] || {}
                if(BigDecimalZero(amount).comparedTo(asksMaxPrice) > 0) {
                    bidsMaxPrice = BigDecimalZero(amount)
                }

                bidsData.push({
                    price : DecimalConvert(price),
                    amount : DecimalConvert(amount)
                })
                if(bidsData.length >= count) {
                    break
                }
            }
            updateDepthData(asksData, asksMaxPrice, 
                            bidsData, bidsMaxPrice)
            
        })
    }

    const updateDepthData = (asksData, asksMaxPrice, bidsData, bidsMaxPrice) => {
        if(marketPrice === '0') {
            return
        }
        const sortAsksData = asksData.sort((a, _) => {
            return BigDecimalZero(marketPrice).comparedTo(BigDecimalZero(a.price))
        });

        const sortBidsData = bidsData.sort((a, b) => {
            return BigDecimalZero(marketPrice).comparedTo(BigDecimalZero(a.price))
        });

        setDepthData({
            asks : {
                max : asksMaxPrice,
                data : sortAsksData
            },
            bids : {
                max : bidsMaxPrice,
                data : sortBidsData
            },
            marketPrice : marketPrice
        })
    }

    //=========================================================
    // # 符号变化保存
    useEffect(() => {
        if(symbol) {
            localStorage.setItem('coin_symbol', symbol)
            //=========================================================
            // # 符号变化恢复默认参数
            if(!priceType) {
                 setPrice(marketPrice + '') // 首次市场价
            }
            //=========================================================
        }
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 计数器更新深度数据
    useEffect(() => {
        if(symbol) {
            localStorage.setItem('coin_symbol', symbol)
            if(marketPrice !== '0') {
                requestDepthData()
            }
        }
    }, [symbol, marketPrice, updateCounter]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 交易类型变化
    useEffect(() => {
        if(isLogin()) {
            const name = symbol.split('/')[0]
            setTradeButtonText(tradeType ? `Buy ${name}` : `Sell ${name}`)
        } else {
            setTradeButtonText('Login to trade')
        }
        
    }, [symbol, tradeType]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 资产监听和刷新
    useEffect(() => {
        if(isLogin()) {
            AssetsListener('1', 'CoinTradeViewController', ({data = []}) => {
                setAssetsData(data)
            })
            return () => {
                AssetsListenerRemove('1', 'CoinTradeViewController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(symbol && isLogin() && assetsData.length > 0) {
            const currencys = symbol.split('/') // BTC/USDT
            if(currencys.length !== 2) {
                return
            }
            let a = currencys[0] // BTC
            let b = currencys[1] // USDT
            for(let i=0;i<assetsData.length;i++) {
                const item = assetsData[i];
                if(a === item.symbol) {
                    setSellAssets({...item})
                }
                else if(b === item.symbol) {
                    setBuyAssets({...item})
                }
            }
        }
    }, [symbol, assetsData]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // 滑竿变化
    useEffect(() => {

        let tradePrice = price.length > 0 ? price : marketPrice
        if(DecimalComparedToZero(tradePrice) <= 0) {
            setTradeValue('0.00')
            setAmount('')
            return
        }

        if(tradeType) {
            // # Buy
            const {available = '0.00'} = buyAssets
            if(DecimalComparedToZero(available) > 0) {
                const spend = BigDecimalZero(available).mul(BigDecimalZero(sliderValue).div(BigDecimalZero(100)))
                setTradeValue(DecimalConvert(spend.toString()))
    
                const amount = spend.div(BigDecimalZero(tradePrice)).toString()
                setAmount(DecimalConvert(amount))
            } else {
                setTradeValue('0.00')
                setAmount('')
            }
        }
        else {
            // # Sell
            const {available = '0.00'} = sellAssets
            if(DecimalComparedToZero(available) > 0) {
                const amount = BigDecimalZero(available).mul(BigDecimalZero(sliderValue).div(BigDecimalZero(100)))
                setAmount(DecimalConvert(amount.toString()))

                const spend = amount.mul(BigDecimalZero(tradePrice)).toString()
                setTradeValue(DecimalConvert(spend))
            } else {
                setTradeValue('0.00')
                setAmount('')
            }
        }
    }, [tradeType, price, sliderValue, buyAssets, sellAssets]) // eslint-disable-line react-hooks/exhaustive-deps
    // marketPrice

    //=========================================================

    // # 提交交易
    const postTrade = () => {
        if(!isLogin()) {
            props.navpush('/login')
            return
        }
        
        if(!symbol) {
            ToastContent('Currency cannot be empty')
            return
        }
        
        if(DecimalComparedToZero(marketPrice) <= 0) {
            ToastContent('No transaction price data')
            return
        }
        
        if(DecimalComparedToZero(amount) <= 0) {
            ToastContent('Invalid transaction amount')
            return
        }

        const tradePrice = price.length > 0 ? price : marketPrice
        if(DecimalComparedToZero(tradePrice) <= 0) {
            ToastContent('No unit price or invalid')
            return
        }

        // # 买卖转换余额（买：消耗多少，卖：可以得到多少）
        if(DecimalComparedToZero(tradeValue) <= 0) {
            ToastContent('Abnormal data matching')
            return
        }

        // # 最低购买数量
        if(tradeType) {
            const {buy_mini_mum = '0'} = symbolData || {}
            if(DecimalComparedToZero(buy_mini_mum) > 0) {
                if(BigDecimalZero(tradeValue).comparedTo(BigDecimalZero(buy_mini_mum)) < 0) {
                    ToastContent(`Minimum buy ${buy_mini_mum} USDT`)
                    return
                }
            }
        }

        // # 发起买卖交易
        ToastLoading(tradeType ? 'Buy Posting' : 'Sell Posting')
        const data = {
            symbol : symbol,
            price : BigDecimalZero(tradePrice).toString(),
            amount : BigDecimalZero(amount).toString(),
            balance : BigDecimalZero(tradeValue).toString()
        }
        
        SendTradeCoin(tradeType, data).then((res) => {
            ToastClear()
            const status = res.data.status ?? 200
            if(status === -405) {
                ToastContent('You have been banned from trading')
                return
            }
            refreshTradeData()
            RefreshAssets('1')
        }).catch(()=> {
            ToastContent('Error')
        })
    }

    // # 关注符号
    const [followed, setFollowed] = useState(false);
    useEffect(() => {
        if(isLogin()) {
            setFollowed(symbolData.isFollowed === true)
        }
    }, [symbolData]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{padding : '0 18px'}}>
            <ListView>
                <List.Item style={{margin : '10px 0'}}>
                    <TradeHeaderView
                        followed={followed}
                        data={symbolData}
                        onClick={()=>{props.visibleMarketPopup('1')}}
                        goTrend={()=>{props.navpush('/trend', false, symbolData)}}
                    />
                </List.Item>
                <List.Item>
                    <TradeCoinsBodyView depthData={depthData}>
                        <Space direction='vertical' style={{'--gap-vertical' : '13px', width : '100%'}}>
                            <DividerTradeView
                                onChange={(val)=>{setTradeType(val)}}
                                color = {tradeType ? '#08BF89' : '#D92727'}
                                left={tradeType} 
                                leftText="Buy" 
                                rightText="Sell"
                            />
                            <TabsView fontSize='15px' onChange={(key)=>{
                                setPrice(key === '1' ? '' : marketPrice);
                                setPriceType(key === '1')
                            }}>
                                <Tabs.Tab title="Market Order" key={'1'}/>
                                <Tabs.Tab title="Limit Order" key={'2'}/>
                            </TabsView>
                            <InputView 
                                title='Price' 
                                color='#ccc' 
                                placeholder={priceType ? 'Curent base price' : ''} 
                                readOnly={priceType}
                                value={price} 
                                onChange={val => {
                                    
                                    if(DecimalComparedToZero(val) >= 0) {
                                        if(BigDecimalZero(val).decimalPlaces() <= 8) {
                                            setPrice(val)
                                        }
                                    }
                                }}
                            />

                            <InputView title='Amount' color='#ccc' readOnly={true} value={amount} onChange={val => {
                                setAmount(val);
                            }}/>
                            
                            {
                                tradeType ? 
                                (<div style={{fontSize : '12px'}}>Avaliable {buyAssets.available} {buyAssets.symbol}</div>) : 
                                (<div style={{fontSize : '12px'}}>Avaliable {sellAssets.available} {sellAssets.symbol}</div>)
                            }

                            <Slider 
                                onChange={(val)=>{
                                    setPerValue(0)
                                    setSliderValue(val)
                                }} 
                                value={sliderValue} 
                                icon={<div style={{
                                        background : '#FFF',
                                        width: '100%',
                                        height : '100%',
                                        display : 'flex',
                                        alignItems : 'center',
                                        justifyContent : 'center',
                                        border: '2px '+(tradeType ? '#08BF89' : '#D92727')+' solid',
                                        borderRadius : '100px',
                                        boxSizing : 'border-box'
                                    }}>{sliderValue}</div>} 
                                style={{'--fill-color' : tradeType ? '#08BF89' : '#D92727'}}
                            />

                            <Selector columns={optionsData.length} options={optionsData} showCheckMark={false} style={{
                                '--padding' : '3.5px 0', 
                                '--border-radius' : '6px',
                                '--border': 'solid #F1F1F1 1px',
                                '--text-color' : '#A0A0A0',
                                '--checked-border': 'solid '+(tradeType ? '#08BF89' : '#D92727')+' 1px',
                                '--checked-color' : tradeType ? '#08BF89' : '#D92727',
                                '--color' : 'transparent',
                                '--checked-text-color' : '#FFF',
                                fontSize : '12px'}}
                                value={perValue}
                                onChange={(val)=> {
                                    setPerValue(val)
                                    setSliderValue(val.length > 0 ? val[0] : 0)
                                }}
                            />

                            {
                                tradeType ? 
                                (<div style={{fontSize : '12px'}}>Spend {tradeValue} {buyAssets.symbol}</div>) : 
                                (<div style={{fontSize : '12px'}}>Estimate {tradeValue} {buyAssets.symbol}</div>)
                            }
                            <TradeButtonView onClick={postTrade} style={{background : TradeLightValueColor(tradeType, true)}}>{tradeButtonText}</TradeButtonView>
                        </Space>
                    </TradeCoinsBodyView>
                </List.Item>

                <List.Item style={{fontSize : '18px', fontWeight : 'bold', margin : '15px 0'}}>
                    <div style={{display : 'flex', alignItems : 'center'}}>
                        <div style={{flex : '1'}}>Open orders</div>
                        <div onClick={()=>{props.loginpush('./coins/order')}}><NavbarHistoryIcon/></div>
                    </div>
                </List.Item>
                
                <CellStateView stateType={stateCode} onRefresh={requestUnDoneData}/>
                {
                    orderData.map((item, index) => (
                        <CoinCellView data={item} key={index} onUndo={()=>{onUndo(item)}}/>
                    ))
                }
            </ListView>
        </div>
    )
})